import '../../styles/pages/app-loading.scss';
import ContentLoadingIndicator from '../components/loading-indicators/content';
import React from 'react';
import useDocumentTitle from '../hooks/utility/use-document-title';
import { useTranslation } from 'react-i18next';

//

function AppLoadingPage() {
  const { t: translate } = useTranslation('pages/app-loading');

  //
  // Side-Effects

  useDocumentTitle(translate('loading', ''));

  //
  // Render

  return (
    <ContentLoadingIndicator className="loading-app-page">
      {translate('loading', '')}
    </ContentLoadingIndicator>
  );
}

// Exports
// -------

export default AppLoadingPage;
